<template>
  <!--  单价合同工作量核定单-->
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed; top: 0; z-index: 999; width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>
    <div v-show="businessType==='contract'">
      <van-collapse v-model="activeNames">
        <van-collapse-item title="基本信息" name="1">
          <van-field v-model="inputForm.contractCode" label="合同编号" label-width="100px" readonly input-align="left"
                     :border="false" autosize rows="1" type="textarea"/>
          <van-field v-model="inputForm.contractName" label="合同名称" label-width="100px" readonly input-align="left"
                     :border="false" autosize rows="1" type="textarea"/>
<!--          <van-field v-model="inputForm.contractCategoryName" label="合同类别" label-width="100px" readonly input-align="left"-->
<!--                     :border="false" autosize rows="1" type="textarea"/>-->
          <van-field v-model="inputForm.budgetItemsName" label="所属项目" label-width="100px" readonly input-align="left"
                     :border="false" autosize rows="1" type="textarea"/>
          <van-field v-model="inputForm.contractPartyJiaName" label="合同甲方" label-width="100px" readonly input-align="left"
                     :border="false" autosize rows="1" type="textarea"/>
          <van-field v-model="inputForm.contractPartyYiSupplierName" label="合同乙方" label-width="100px" readonly
                     input-align="left" :border="false" autosize rows="1" type="textarea"/>
<!--          <van-field v-model="inputForm.contractPartyBingSupplierName" label="合同丙方" label-width="100px" readonly-->
<!--                     input-align="left" :border="false" autosize rows="1" type="textarea"/>-->
          <van-field v-model="inputForm.createByName" label="制单人" label-width="100px" readonly input-align="left"
                     :border="false" autosize rows="1" type="textarea"/>
          <van-field v-model="inputForm.operatorName" label="经办人" label-width="100px" readonly input-align="left"
                     :border="false" autosize rows="1" type="textarea"/>
          <van-field v-model="inputForm.operatorDeptName" label="经办部门" label-width="100px" readonly input-align="left"
                     :border="false" autosize rows="1" type="textarea"/>
          <van-field v-model="inputForm.estimateAmount" label="本次核定总额(元)" label-width="100px" :formatter="formatterNumber"
                     readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
          <van-field v-model="inputForm.createDate" label="制单日期" label-width="100px" readonly input-align="left"
                     :border="false" autosize rows="1" type="textarea"/>
          <van-field v-model="inputForm.estimateDate" label="核定区间" label-width="100px" readonly input-align="left"
                     :border="false" autosize rows="1" type="textarea"/>
          <van-field v-show="inputForm.contractCategory === '4'" v-model="inputForm.unitCategoryName" label="单价类型"
                     label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        </van-collapse-item>
        <van-collapse-item title="关联业务明细" name="2" v-if="inputForm.workloadEstimateRellList && inputForm.workloadEstimateRellList.length>0">
          <b-table class="bgc-dark" small head-variant="dark" responsive bordered
                   :items="inputForm.workloadEstimateRellList" :fields="fields" foot-clone>
            <template v-slot:head()="scope">
              <div class="text-nowrap" :style="{textAlign:'center'}">
                {{ scope.label }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              {{ data.index + 1 }}
            </template>
            <template v-slot:cell(unitPrice)="data">
              {{ (Number(data.item.unitPrice)).toFixed(2) }}
            </template>
            <template v-slot:cell(num)="data">
              {{ (Number(data.item.num)).toFixed(2) }}
            </template>
            <template v-slot:cell(amount)="data">
              {{ (Number(data.item.amount)).toFixed(2) }}
            </template>
            <template v-slot:cell(businessInfo)="data">
              <div style="color: #4caedc" @click="showDetail(data.item.businessInfo)">{{ data.item.businessInfo }}</div>
            </template>

            <template v-slot:table-colgroup="scope">
              <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="{ width: field.width }"
              >
            </template>
            <template v-slot:foot()="scope">
              <div class="text-nowrap" :style="{textAlign:'center'}"></div>
            </template>
            <template v-slot:foot(index)="data">
              <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
            </template>
            <template v-slot:foot(num)="data">
              <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(inputForm.workloadEstimateRellList,'num')}}</div>
            </template>
            <template v-slot:foot(amount)="data">
              <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(inputForm.workloadEstimateRellList,'amount')}}</div>
            </template>
          </b-table>
        </van-collapse-item>
        <van-collapse-item title="单价合同工作量核定明细" name="3">
          <div style="padding-left: 16px; margin-bottom: 10px; margin-top: 10px">
            <p style="display: block; color: #4caedc" @click="viewWorkloadEstimateDetail()">查看合同工作量核定明细</p>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <eventWorkloadEstimate ref="eventWorkloadEstimate" v-show="businessType==='event'"></eventWorkloadEstimate>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import processRecord from "../../../../components/processRecord/processRecord";
import Decimal from "decimal.js";
import TaskService from "../../../../api/flowable/TaskService";
import ProcessService from "../../../../api/flowable/ProcessService";
import eventWorkloadEstimate from "../event/eventWorkloadEstimate";
import Vue from "vue";
import flowSettingService from "../../../../api/sys/flowSettingService";

export default {
  name: "contractWorkloadEstimate",
  data() {
    return {
      activeNames: ['1', '2', '3'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type: '',
      businessType: '',
      subjectTypeList: [],
      activeName: '',
      inputForm: {
        attachList: []
      },
      contractCategoryData: [
        {
          value: '1',
          label: '工程施工'
        },
        {
          value: '2',
          label: '物料采购'
        },
        {
          value: '3',
          label: '广告宣传'
        },
        {
          value: '4',
          label: '佣金类'
        },
        {
          value: '5',
          label: '其他类'
        }
      ],
      fields: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'businessInfo', label: '业务信息', width: '140px'},
        {key: 'businessDate', label: '业务时间', width: '100px'},
        {key: 'unitPrice', label: '单价', width: '120px'},
        {key: 'num', label: '数量', width: '100px'},
        {key: 'amount', label: '金额', width: '100px'},
      ]
    }
  },
  components: {
    processRecord,
    eventWorkloadEstimate
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    // let id = '1873641167820779521'//事项单
    // let id = '1871754756458930177'//合同
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.inputForm.id = id
      this.$nextTick(()=>{
        this.$flow.queryById(id, '/event/costContractWorkloadEstimate/getBaseInfo').then(({ data }) => {
          if(data.contractId!=='0'&&data.eventId==='0'){
            this.$flow.queryById(id, '/contract/costContractWorkloadEstimate/queryById').then(({data}) => {
              this.inputForm = data
              this.businessType='contract'
              this.inputForm.createDate = this.inputForm.createDate.slice(0, 10)
              this.inputForm.estimateDate = this.inputForm.estimateDateStart + ' 至 ' + this.inputForm.estimateDateEnd
              this.inputForm.unitCategoryName = this.inputForm.unitCategory === '1' ? '单价' : '比例'
              this.$set(this.inputForm, 'contractCategoryName', this.contractCategoryData.find(item => item.value == data.contractCategory).label)
            }).catch(e => {
              console.log(e)
            })
          }else {
            this.$flow.queryById(id, '/event/costContractWorkloadEstimate/queryById').then(({data}) => {
              this.inputForm = data
              this.businessType='event'
              this.$refs.eventWorkloadEstimate.init(data)
            }).catch(e => {
              console.log(e)
            })
          }
        }).catch(e => {
          console.log(e)
        });
      })
    },
    close() {
      if (this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(async () => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        // vars = {...vars, ..._this.inputForm}
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask ? '_flow_approval' : '_flow_agree'
        if(this.businessType==='event'){
          let sendBy = ''
          let sendByDeptId = ''
          let sendByCompanyId = ''
          if(this.inputForm.flowStatus === 1) {
            sendBy = Vue.cookie.get('userId');
            const res1 = await new flowSettingService().queryUser(sendBy)
            sendByDeptId = res1.data.officeDTO.id
            sendByCompanyId = res1.data.companyDTO.id
          } else {
            const res3 = await new TaskService().queryByProcInsId(this.inputForm.procInsId)
            sendBy = res3.data.createBy
            sendByDeptId = res3.data.createDept
            sendByCompanyId = res3.data.createCompany
          }
          let createByDeptId = ''
          let createByCompanyId = ''
          const res2 = await new flowSettingService().queryUser(this.inputForm.createById)
          createByDeptId = res2.data.officeDTO.id
          createByCompanyId = res2.data.companyDTO.id
          // vars = { ...vars, ..._this.inputForm }
          vars = {
            sendBy: sendBy,
            sendByDeptId: sendByDeptId,
            sendByCompanyId: sendByCompanyId,
            createByDeptId: createByDeptId,
            createByCompanyId: createByCompanyId,
            createBy: this.inputForm.createById,
            operatorId: this.inputForm.operatorId,
            operatorDeptId: this.inputForm.operatorDeptId,
            paymentCompanyId: this.inputForm.contractPartyJiaId
          }
        } else {
          let sendBy = ''
          let sendByDeptId = ''
          let sendByCompanyId = ''
          if(this.inputForm.flowStatus === 1) {
            sendBy = Vue.cookie.get('userId');
            const res1 = await new flowSettingService().queryUser(sendBy)
            sendByDeptId = res1.data.officeDTO.id
            sendByCompanyId = res1.data.companyDTO.id
          } else {
            const res3 = await new TaskService().queryByProcInsId(this.inputForm.procInsId)
            sendBy = res3.data.createBy
            sendByDeptId = res3.data.createDept
            sendByCompanyId = res3.data.createCompany
          }
          let createByDeptId = ''
          let createByCompanyId = ''
          const res2 = await new flowSettingService().queryUser(this.inputForm.createById)
          createByDeptId = res2.data.officeDTO.id
          createByCompanyId = res2.data.companyDTO.id
          // vars = { ...vars, ..._this.inputForm }
          vars = {
            sendBy: sendBy,
            sendByDeptId: sendByDeptId,
            sendByCompanyId: sendByCompanyId,
            createByDeptId: createByDeptId,
            createByCompanyId: createByCompanyId,
            createBy: this.inputForm.createById,
            contractCategory: this.inputForm.contractCategory,
            operatorId: this.inputForm.operatorId,
            operatorDeptId: this.inputForm.operatorDeptId,
            paymentCompanyId: this.inputForm.contractPartyJiaId
          }
        }
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          if(this.businessType==='contract'){
            _this.$flow.startFlow(form, '/contract/costContractWorkloadEstimate/startFlow');
          }else {
            _this.$flow.startFlow(form, '/event/costContractWorkloadEstimate/startFlow');
          }

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey
          }
          if(this.businessType==='contract'){
            _this.$flow.startFlow(form, '/contract/costContractWorkloadEstimate/startFlow');
          }else {
            _this.$flow.startFlow(form, '/event/costContractWorkloadEstimate/startFlow');
          }

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    formatterNumber(value) {
      return Number(value).toFixed(2)
    },
    formatterYN(value) {
      return value === '1' ? '是' : '否'
    },
    // 将数字转为大写
    numberToChinese(Amount) {
      if (Amount === 0) {
        return '零圆'
      }
      let amount = Math.abs(Amount)
      let tempAmount = ''
      if (amount !== '' && amount != null && amount !== '0') {
        let unit = '仟佰拾亿仟佰拾万仟佰拾圆角分'
        let str = ''
        amount += '00'
        const point = amount.indexOf('.')
        if (point >= 0) {
          amount = amount.substring(0, point) + amount.substr(point + 1, 2)
        }
        unit = unit.substr(unit.length - amount.length)
        for (let i = 0; i < amount.length; i++) {
          str += '零壹贰叁肆伍陆柒捌玖'.charAt(amount.charAt(i)) + unit.charAt(i)
        }
        tempAmount = str.replace(/零(仟|佰|拾|角)/g, '零')
            .replace(/(零)+/g, '零')
            .replace(/零(万|亿|圆)/g, '$1')
            .replace(/(亿)万|(拾)/g, '$1$2')
            .replace(/^圆零?|零分/g, '')
            .replace(/元$/g, '圆');
      }
      if (Amount < 0) {
        tempAmount = '负' + tempAmount
      }
      return tempAmount;
    },
    viewWorkloadEstimateDetail() {
      this.$router.push({
        path: '/cost_contract_workload_estimate_detail',
        query: {
          unitCategory: this.inputForm.unitCategory,
          data: JSON.stringify(this.inputForm.workloadEstimateDetailList)
        }
      })
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(2, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    showDetail(content) {
      if(content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
  }
}
</script>

<style scoped>

</style>
